<link href='https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css' rel='stylesheet'>


<button id="signButton" class="btn btn-sign-up text-uppercase">Signup NOW!</button>
<div class="RightSidbar">
	<span class="cross-menus"></span>

	<p class="py-1"></p>
	<div class="rightMain">
		<h3 class="sign-sub-title mb-0 text-uppercase">SIGN UP FOR A,</h3>
		<h2 class="sign-title text-uppercase">Strategic Alliance</h2>
		<hr class="sign-hr">

		<div class="sign-input-group">
			<input type="text" class="form-control sign-input" placeholder="First Name">
		</div>

		<div class="sign-input-group">
			<input type="text" class="form-control sign-input" placeholder="Last Name">
		</div>

		<div class="sign-input-group">
			<input type="tel" class="form-control sign-input" placeholder="Mobile Number">
		</div>

		<div class="sign-input-group">
			<input type="email" class="form-control sign-input" placeholder="Email">
		</div>
		<p class="py-1"></p>
		<div class="sign-input-btn">
			<button class="btn btn-default pink-color text-uppercase">Signup NOW!</button>
		</div>
	</div>
</div>
<div class="bg-overlay"></div>

<page-header></page-header>

<router-outlet></router-outlet>
<page-footer></page-footer>

<!--<div class="container">
		<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#ThankSubscribe">
		  Launch demo modal
		</button>
		<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#ThankContact">
		  Launch demo modal
		</button>
	</div>-->

<!-- Modal ThankSubscribe -->
<div class="modal fade" id="ThankSubscribe" tabindex="-1" aria-labelledby="ThankSubscribeLabel" aria-hidden="true">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-body">
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				<div class="modal-bag">
					<div class="thank-logo-img text-center">
						<img src="../assets/images/thank-you-icon.png" class="img-fluid">
					</div>
					<p class="py-2"></p>
					<h4 class="sub-title mb-1 text-center text-uppercase">Thank You</h4>
					<h2 class="title text-center text-uppercase">For Subscribing</h2>
					<div class="text-center py-1"><img src="../assets/images/pop-shad-a.png" class="img-fluid"></div>
					<h5 class="sub-title-a text-center">To Wise Owlzz Newsletter</h5>
					<p class="py-1"></p>
					<div class="button text-center">
						<a class="btn btn-default text-uppercase" href="index.html">BACK TO Home</a>
					</div>
				</div>
			</div>

		</div>
	</div>
</div>

<!-- Modal ThankContact -->
<div class="modal fade" id="ThankContact" tabindex="-1" aria-labelledby="ThankContactLabel" aria-hidden="true">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-body">
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				<div class="modal-bag">
					<div class="thank-logo-img text-center">
						<img src="../assets/images/thank-you-contact-icon.png" class="img-fluid">
					</div>
					<p class="py-2"></p>
					<h4 class="sub-title mb-1 text-center text-uppercase">Thank You</h4>
					<h2 class="title text-center text-uppercase">For Contacting Us</h2>
					<div class="text-center py-1"><img src="../assets/images/pop-shad-a.png" class="img-fluid"></div>
					<h5 class="sub-title-a text-center">We will get back to you shortly!</h5>
					<p class="py-1"></p>
					<div class="button text-center">
						<a class="btn btn-default text-uppercase" href="index.html">BACK TO Home</a>
					</div>
				</div>
			</div>

		</div>
	</div>
</div>